import { Component, ElementRef, OnInit, SecurityContext, ViewChild } from '@angular/core';
import * as pbi from 'powerbi-client';
import { environment } from '../../environments/environment';
import { ApiService } from '../api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, filter, throwError } from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss'
})
export class ReportComponent implements OnInit {
  embedUrl:string = "";
  currentYear: number = new Date().getFullYear();
  @ViewChild('reportContainer', { static: true }) reportContainer: ElementRef | any;
  
  
  Token: any;

  private baseUrl = environment.apiUrl;
  PageName: any;
  filterString: string='';
    constructor(private sanitizer: DomSanitizer,private _httpClient: HttpClient,private router: Router,private activatedRoute: ActivatedRoute) { }
  
  ngOnInit(): void {
    
    const currentURL = this.router.url;
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const key = Object.keys(queryParams)[0];     // vendor OR menu
    const value = queryParams[key];

    if(key && value) {
      if(key=='menu')
      {
        this.filterString = encodeURIComponent(`ICITEM/DESC eq '${value}'`);
        this.PageName = '834d9a58918e74a66134'
      }else if(key=='vendor')
      {
        this.filterString = encodeURIComponent(`APVEN/VENDNAME eq '${value}'`);
        this.PageName = '82488671fc56f75b5c9b'
      }
      this.embedUrl = environment.reportUrl + `&filter=${this.filterString}`;
    }
    console.log('Embed URL:', this.embedUrl);
    console.log('PageName', this.PageName);
    this.getAccessToken().subscribe((result: any) => {
    if (result) {
      let jsonstring =JSON.parse(result);
      this.Token = jsonstring["access_token"];

    let config = {
      type: 'report',
      accessToken: this.Token,
      embedUrl: this.embedUrl,
      id: environment.reportID,
      pageName: this.PageName,
      permissions: pbi.models.Permissions.All,
      bootstrapped: true,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        layoutType: pbi.models.LayoutType.Custom,
        displayOption: pbi.models.DisplayOption.FitToPage,
        customLayout: {
          displayOption: pbi.models.DisplayOption.FitToPage,
        },
      }
    };


  const updateConfigForOrientation = () => {
      let displayOption = pbi.models.DisplayOption.FitToPage;
      config.settings.displayOption = displayOption;
      config.settings.customLayout.displayOption = displayOption;
      if (this.embedUrl) {
        const reportCntr = this.reportContainer.nativeElement;
        const powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
        );
        powerbi.reset(reportCntr);
        powerbi.embed(reportCntr, config);
      }
    };

    // Initial setup for orientation
    updateConfigForOrientation();
    // Add event listener for orientation change
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        updateConfigForOrientation();
      } , 100); // Delay to ensure resize is complete
    });


    if(this.embedUrl){
    let reportCntr = this.reportContainer.nativeElement;
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory); 
    powerbi.reset(reportCntr);
    var report = powerbi.embed(reportCntr, config);
    report.off("loaded");
    report.on("loaded", function () {
      console.log("Loaded");
    });
    report.off("rendered");
    report.on("rendered", function () {
      
    });
   report.on("selectionChanged", () => { 
  });

  report.on("visualClicked", () => { 
  });
    report.on("error", function (event) {
    report.off("error");
    });
    report.off("saved");
    report.on("saved", function (event) {
    });

  }
        }
      });

    

  }


  getAccessToken() {
      var urlPath = this.baseUrl + "/api/PowerBI/AccessTokenAsync";
      let pdfSrc = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(urlPath)) as string;
      return this._httpClient.get(pdfSrc)
        .pipe(catchError(this.handleError1));
    }

    public handleError1(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log("Client Side Error =" + error.message);
        } else {
          console.log("Server Side Error=" + error.message);
        }
        return throwError(error);
      }


}
